<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <!-- <el-select v-model="queryForm.vendorIdList" multiple collapse-tags filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select> -->
                  <BrandSelect :data="vendorList" v-model="queryForm.vendorIdList"  multiple collapse-tags filterable clearable></BrandSelect>
                </el-form-item>
              </el-col>
              <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="营业状态">
                  <el-select v-model="queryForm.vendorStatusList" multiple collapse-tags clearable>
                    <el-option v-for="item in vendorStatusList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="业务类型">
                  <el-select v-model="queryForm.vendorTypeList" multiple collapse-tags clearable>
                    <el-option v-for="item in vendorTypeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="对接类型">
                  <el-select v-model="queryForm.productSourceTypeList" multiple collapse-tags clearable>
                    <el-option v-for="item in vendorProductSourceTypeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="业务分区">
                  <el-select v-model="queryForm.businessRegionIdList" multiple collapse-tags clearable>
                    <el-option v-for="(item, idx) in businessRegionList" :key="idx" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="创建时间">
                  <el-date-picker
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable
                    placeholder="请选择时间"
                    v-model="daterange"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="制作级别">
                  <el-select v-model="queryForm.productLevel" multiple clearable>
                    <el-option label="A" value="A"></el-option>
                    <el-option label="B" value="B"></el-option>
                    <el-option label="C" value="C"></el-option>
                    <el-option label="D" value="D"></el-option>
                    <el-option label="E" value="E"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="是否有推图">
                  <el-select v-model="queryForm.haveImage" clearable>
                    <el-option label="有推图" :value="true"></el-option>
                    <el-option label="无推图" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="是否有库存">
                  <el-select v-model="queryForm.haveStock" clearable>
                    <el-option label="有库存" :value="true"></el-option>
                    <el-option label="无库存" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="处理状态">
                  <el-select v-model="queryForm.processStatus" multiple clearable>
                    <el-option label="待处理" :value="0"></el-option>
                    <el-option label="不制作类目" :value="1"></el-option>
                    <el-option label="搜索不到" :value="2"></el-option>
                    <el-option label="平台未售卖品牌" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="处理时间">
                  <el-date-picker
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable
                    placeholder="请选择时间"
                    v-model="daterange2"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                we<el-form-item label="品牌">
                  <BrandSelect v-model="queryForm.brandIds" :data="brandList" :clearable="true" :multiple="true"></BrandSelect>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="top100品牌">
                  <el-select v-model="queryForm.isTopBrand" clearable>
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-button @click="batchEdit" :disabled="selection.length === 0" type="primary">品类信息补充</el-button>
    <el-button @click="batchProcess" :disabled="selection.length === 0" type="primary">打标处理</el-button>

    <el-table :data="tableData" @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="" width="80" class-name="nopadding">
        <template slot-scope="scope">
          <list-img :key="scope.row.boutiqueProductId" :img="scope.row.images" :width="30"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="vendorName" label="买手店名称"></el-table-column>
      <el-table-column prop="designerId" label="货号"></el-table-column>
      <el-table-column prop="colorCode" label="颜色"></el-table-column>
      <el-table-column prop="brandName" label="品牌"></el-table-column>
      <el-table-column prop="categoryNamePatch" label="类目"></el-table-column>
      <el-table-column prop="productName" label="商品名称"></el-table-column>
      <el-table-column prop="description" label="描述" min-width="200">
        <template slot-scope="scope">
          <p class="description" :title="scope.row.description">{{ scope.row.description }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="editProcessStatus" label="处理结果" min-width="120">
        <template slot-scope="scope">
          <el-select v-model="scope.row.editProcessStatus" @change="(val) => onChangeProcessStatus(val, scope.row)" clearable placeholder="请选择">
            <el-option label="不制作类目" :value="1"></el-option>
            <el-option label="搜索不到" :value="2"></el-option>
            <el-option label="平台未售卖品牌" :value="3"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editCategory(scope.row)">品类信息补充</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="品类信息补充" :visible.sync="dialogVisible" width="400px">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item prop="brandId" label="品牌" :rules="[{ required: true, message: '请选择品牌' }]">
          <BrandSelect v-model="form.brandId" :disabled="disabledBrand" :data="brandList"></BrandSelect>
        </el-form-item>
        <el-form-item prop="categoryId" label="类目" :rules="[{ required: true, message: '请选择类目' }]">
          <el-cascader
            :disabled="disabledCategory"
            v-model="form.categoryId"
            :options="categoryList"
            :props="optionProps"
            :style="{width: '100%'}"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="打标处理" :visible.sync="dialogVisible2" width="400px">
      <el-select v-model="form2.processStatus" clearable>
        <el-option label="待处理" :value="0"></el-option>
        <el-option label="不制作类目" :value="1"></el-option>
        <el-option label="搜索不到" :value="2"></el-option>
        <el-option label="平台未售卖品牌" :value="3"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitProcess">提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  queryVendorList,
} from '../../../api/mapping_cn';
import {
  getVendorStatusList,
  getVendorType,
  getProductSourceTypeList,
  getBusinessRegionList,
} from '../../buyershop/cn/api';
import { getBrandList } from '../../seller/api_cn';
import {
  getIncompleteProductList,
  incompleteProductPublish,
  validateIncompleteProduct,
  batchProcessIncompleteProduct,
} from './api'
import { getCategory, } from '../../../api/mapping_cn';
import BrandSelect from '../../shared/brandSelect.vue';
import ListImg from '../../shared/ListImg.vue';

export default {
  components: {
    BrandSelect,
    ListImg,
  },
  data() {
    return {
      loading: false,
      vendorList: [],
      vendorStatusList: [],
      vendorTypeList: [],
      vendorProductSourceTypeList: [],
      businessRegionList: [],
      daterange: [],
      brandList: [],
      categoryList: [],
      daterange2: [],
      queryForm: {
        vendorAliasIdList: [],
        vendorIdList: [],
        vendorStatusList: [],
        vendorTypeList: [],
        productSourceTypeList: [],
        businessRegionIdList: [],
        productLevel: [],
        haveImage: null,
        // haveStock: null,
        processStatus: [0],
        scrollId: null,
        brandIds: null,
        isTopBrand: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      selection: [],
      dialogVisible: false,
      form: {
        boutiqueProductIdList: [],
        brandId: null,
        categoryId: null,
      },
      disabledBrand: false,
      disabledCategory: false,
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        children: 'children',
        label: 'chineseName',
        value: 'categoryId',
      },
      dialogVisible2: false,
      form2: {
        processStatus: null,
      },
    };
  },
  mounted() {
    queryVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data.map(item => ({
          value: item.vendorId,
          label: item.vendorName,
          vendorNameAlias: item.vendorNameAlias,
        }));
      }
    });
    getVendorStatusList().then(res => {
      if (res.data) {
        this.vendorStatusList = (res.data.data || []).map(item => ({
          label: item.desc,
          value: item.value,
        }));
      }
    });
    getVendorType().then(res => {
      if (res.data) {
        this.vendorTypeList = (res.data.data || []).map(item => ({
          label: item.desc,
          value: item.value,
        }));
      }
    })
    getProductSourceTypeList().then(res => {
      if (res.data) {
        this.vendorProductSourceTypeList = (res.data.data || []).map(item => ({
          label: item.desc,
          value: item.value,
        }));
      }
    })
    getBusinessRegionList().then(res => {
      if (res.data) {
        this.businessRegionList = (res.data.data || []).map(item => ({
          label: item.businessRegionName,
          value: item.businessRegionId,
        }));
      }
    })
    getBrandList().then(res => {//获取品牌列表
      this.brandList = (res.data || []).map(item => {
        return {
          label: item.englishName,
          value: item.brandId
        };
      });
    });
    getCategory().then(res => {
      if (res.data && res.data.data) {
        this.categoryList = res.data.data;
        this.selectedAllIds = []
        this.categoryList.forEach(item => {
          item.children.forEach((item2) => {
            item2.children.forEach(item3 => {
              this.selectedAllIds.push(item3.categoryId)
            })
          })
        })
      }
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.queryForm.scrollId = null;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorAliasIdList = [];
      this.queryForm.vendorIdList = [];
      this.queryForm.vendorStatusList = [];
      this.queryForm.vendorTypeList = [];
      this.queryForm.productSourceTypeList = [];
      this.queryForm.businessRegionIdList = [];
      this.queryForm.productLevel = [];
      this.queryForm.haveImage = null;
      // this.queryForm.haveStock = null;
      this.queryForm.processStatus = [0];
      this.queryForm.scrollId = null;
      this.queryForm.pageNo = 1;
      this.daterange = [];
      this.daterange2 = [];
      this.getTableData();
    },
    getTableData() {
      getIncompleteProductList({
        ...this.queryForm,
        vendorIdList: this.queryForm.vendorAliasIdList.length > 0 ? this.queryForm.vendorAliasIdList : this.queryForm.vendorIdList,
        startTime: this.daterange ? this.daterange[0] : null,
        endTime: this.daterange ? this.daterange[1] : null,
        processStartTime: this.daterange2 ? this.daterange2[0] : null,
        processEndTime: this.daterange2 ? this.daterange2[1] : null,
      }).then(res => {
        if (res.data) {
          this.total = res.data.total;
          this.tableData = (res.data.list || []).map(item => {
            item.editProcessStatus = item.processStatus;
            return item;
          });
          this.queryForm.scrollId = res.data.scrollId;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.queryForm.scrollId = null;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      if(pageNo < this.queryForm.pageNo){
        this.queryForm.scrollId = null;
      }
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            incompleteProductPublish(this.form).then(res => {
              this.repeatSave = false;
              if (res.success) {
                this.$message.success('补充成功');
                this.dialogVisible = false;
                this.queryForm.scrollId = null;
                this.getTableData();
              } else {
                this.$message.error(res.message || '系统异常，请稍后再试');
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    editCategory(row) {
      this.form.boutiqueProductIdList = [row.boutiqueProductId];
      this.form.brandId = row.brandId || null;
      this.form.categoryId = row.categoryLevel3Id || null;
      this.disabledBrand = Boolean(this.form.brandId);
      this.disabledCategory = Boolean(this.form.categoryId);
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    async batchEdit() {
      this.form.boutiqueProductIdList = this.selection.map(item => item.boutiqueProductId);
      const res = await validateIncompleteProduct(this.form.boutiqueProductIdList);
      if (!res.success) {
        this.$message.error(res.message || '系统异常，请稍后再试');
        return;
      }
      const brandSet = new Set(this.selection.filter(item => item.brandId).map(item => item.brandId));
      const categorySet = new Set(this.selection.filter(item => item.categoryLevel3Id).map(item => item.categoryLevel3Id));
      if (brandSet.size === 1) {
        this.form.brandId = [...brandSet][0];
        this.disabledBrand = true;
      } else {
        this.form.brandId = null;
        this.disabledBrand = false;
      }
      if (categorySet.size === 1) {
        this.form.categoryId = [...categorySet][0];
        this.disabledCategory = true;
      } else {
        this.form.categoryId = null;
        this.disabledCategory = false;
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    batchProcess() {
      if (this.selection.length === 0) {
        this.$message.error('请选择要操作的商品');
        return;
      }
      this.form2.processStatus = null;
      this.dialogVisible2 = true;
    },
    submitProcess() {
      batchProcessIncompleteProduct({
        processBoutiqueProductList: this.selection.map(item => ({
          boutiqueProductId: item.boutiqueProductId,
          processStatus: this.form2.processStatus,
        })),
      }).then(res => {
        if (res.success) {
          this.$message.success('打标成功');
          this.dialogVisible2 = false;
          this.getTableData();
        } else {
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
      }).catch(() => {
        this.$message.error('系统异常，请稍后再试');
      })
    },
    onChangeProcessStatus(val, row) {
      batchProcessIncompleteProduct({
        processBoutiqueProductList: [{
          boutiqueProductId: row.boutiqueProductId,
          processStatus: val,
        }],
      }).then(res => {
        if (res.success) {
          this.$message.success('修改成功');
          row.processStatus = val;
          this.getTableData();
        } else {
          row.editCategory = row.processStatus;
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
      }).catch(() => {
        row.editCategory = row.processStatus;
        this.$message.error('系统异常，请稍后再试');
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
